<template>
  <div>
    <div class="form-group input-group" style="width: 100%;">
      <span style="background: white; width: 140px;" class="input-group-addon"
        ><span>{{ title }}</span></span
      >
      <input
        class="form-control"
        v-model="storeData"
        type="username"
        :placeholder="placeholder"
        :type="type"
        style="z-index: 0;"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "text-input",
  props: ["title", "keyChain", "placeholder", "type"],
  computed: {
    storeData: {
      get: function() {
        return this.$store.getters["getEditedProviderValueByKeyChain"](
          this.keyChain
        );
      },
      set: function(editedData) {
        var payl = {
          data: editedData,
          keyChain: this.keyChain
        };
        this.$store.commit("setEditedProviderByKeyChain", payl);
      }
    }
  }
};
</script>

<style scoped>
body {
  font-family: Arial, Helvetica, sans-serif;
}
* {
  box-sizing: border-box;
}

input[type="text"],
select,
textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 6px;
  margin-bottom: 16px;
  resize: vertical;
}

input[type="submit"] {
  background-color: black;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

input[type="submit"]:hover {
  background-color: grey;
}

.container {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/elements/textInput.vue